import React from 'react';
import { View } from 'react-native';
import { radius, useColors, useTextScale } from '../theme';
import { Icon } from '../icons/Icon';
import type { IconName } from '../icons/Icon';
import { T } from './Text';

export function StatTile({
  value,
  label,
  icon,
}: {
  value: string;
  label: string;
  icon?: IconName;
}) {
  const colors = useColors();
  const scale = useTextScale();
  return (
    <View
      style={{
        flexGrow: 1,
        // The basis grows with the reading size. At Extra large on a 375px
        // phone two tiles still shared a row, and "₹12,614" broke across two
        // lines mid-number — a money figure split like that is not just ugly,
        // it is briefly unreadable. Scaling the basis makes the row hold one
        // tile instead, which is the right answer at that size anyway.
        flexBasis: 150 * scale,
        backgroundColor: colors.surface,
        borderWidth: 1,
        borderColor: colors.line,
        borderRadius: radius.lg,
        paddingVertical: 15,
        paddingHorizontal: 16,
        gap: 8,
      }}
    >
      {icon ? <Icon name={icon} size={16} color={colors.goldDim} /> : null}
      <T size={26} weight={600} serif color={colors.gold}>
        {value}
      </T>
      <T size={11.5} color={colors.textDim} numberOfLines={2}>
        {label}
      </T>
    </View>
  );
}
